import { gql } from '@apollo/client';

export const SIGNATURE_SETTING = gql`
  query Settings {
    signature {
      signature
    }
  }
`;
